import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import Text from 'components/_new/typography/Text/Text'
import Modal from 'components/modal/Modal/Modal'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import { Button, buttonMessages } from 'components/_new/controls'

import s from './DialogModal.scss'


class DialogModal extends Component {

  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      onClose: PropTypes.func,
      isButtonLoading: PropTypes.bool,
      showCloseButton: PropTypes.bool,
      disableClose: PropTypes.bool,
      disableCloseOverlay: PropTypes.bool,
    }),
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    titleUppercase: PropTypes.bool,
    buttonTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    subText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    isWhiteButton: PropTypes.bool,
  }

  static defaultProps = {
    name: constants.modals.Dialog,
  }

  close = () => {
    const { name, data } = this.props

    actions.models.modals.close(name)

    if (data && typeof data.onClose === 'function') {
      data.onClose()
    }
  }

  render() {
    const { children, className, name, data, title, titleUppercase, subText, buttonTitle, isWhiteButton } = this.props
    const { contentMessage } = data || {}

    return (
      <Modal
        name={name}
        title={title}
        titleUppercase={titleUppercase}
        subText={subText}
        data={data}
        className={className}
      >
        <Fragment>
          {
            contentMessage ? (
              <Text
                message={contentMessage}
                size="16-24"
                color="black"
              />
            ) : (
              children
            )
          }
          <ModalFooter>
            <Button
              className={s.button}
              title={buttonTitle || buttonMessages.finish}
              color={isWhiteButton ? 'white' : 'brand'}
              size="md"
              loading={data && data.isButtonLoading}
              dataTestId={constants.testIds.modal.dialogModal.button}
              onClick={this.close}
            />
          </ModalFooter>
        </Fragment>
      </Modal>
    )
  }
}


export default DialogModal
